/**
 * Opens venue search / listing URLs on the public VenueMonk site (not the current app origin).
 * Used after lead form completion so local/staging apps still send users to production listings.
 */
const DEFAULT_LISTING_ORIGIN = 'https://www.venuemonk.com';

export function getVenueListingAbsoluteUrl(pathOrUrl) {
    if (!pathOrUrl || typeof pathOrUrl !== 'string') {
        return '';
    }
    const trimmed = pathOrUrl.trim();
    if (!trimmed) {
        return '';
    }
    if (/^https?:\/\//i.test(trimmed)) {
        return trimmed;
    }
    const base = (
        process.env.REACT_APP_VENUE_LISTING_URL ||
        process.env.NEXT_PUBLIC_VENUE_LISTING_URL ||
        DEFAULT_LISTING_ORIGIN
    ).replace(/\/$/, '');
    const path = trimmed.startsWith('/') ? trimmed : `/${trimmed}`;
    return `${base}${path}`;
}

export function openVenueListingInNewTab(pathOrUrl) {
    const href = getVenueListingAbsoluteUrl(pathOrUrl);
    if (!href) {
        return;
    }
    window.open(href, '_blank', 'noopener,noreferrer');
}
